import { mapState } from 'vuex'
export default {
    computed: {
        ...mapState({
            filter: ({ filtersStore: { filter } }) => filter,
            queries: ({ resourcesStore: { queries } }) => queries,
        }),
    },
    data() {
        return {
            subitem: ''
        };
    },
    methods: {
        // setSortitem() {
        //     if (this.subitem == 'bekeken') {
        //         return this.subitem = false;
        //     }
        //     this.subitem = 'bekeken';
        // },
        activateSortFilter: function(type, name, dir, title, query) {
            let sortQuery = {
                type: type,
                name: name,
                direction: dir,
                title: title,
            };
            let updateQuery = JSON.parse(JSON.stringify(query));
            updateQuery.sort = {
                [name]: dir,
            };
            updateQuery.pagination.page = 1;

            this.$store.commit('filtersStore/setSort', sortQuery);
            this.$store.commit('resourcesStore/updateQuery', updateQuery);
            this.$store.dispatch('resourcesStore/getResources', updateQuery);

            if (!this.isMobile) {
                this.$store.commit('dropdownStore/setDropdown', false);
            }
        },
    }
}